import { AxiosResponse } from 'axios';
import { IGetTimelineFilters, IGetTimelineStopsInfoResponse, IGetTripsTimelineResponse, ITimelineItem } from 'models/http/trip';
import { HttpTimeoutPriority } from 'utils/enums/http-timeout-priority';
import { ModelsNames } from 'utils/enums/model-names';
import { prepareQPFromFilters, serverAxios } from 'utils/http';

class TimelineHttp {
  private static route = `/${ModelsNames.Timeline}`;

  public async timeline(filters: IGetTimelineFilters, abortController?: AbortController): Promise<ITimelineItem[]> {
    const queryParams = prepareQPFromFilters(filters);

    return serverAxios
      .get(`${TimelineHttp.route}/?${queryParams.toString()}`, {
        timeout: HttpTimeoutPriority.Medium,
        signal: abortController?.signal,
      })
      .then((response: AxiosResponse<IGetTripsTimelineResponse>) => {
        return response.data.timeline;
      });
  }

  public async getTimelineStopsByTripId(id: number, abortController?: AbortController): Promise<IGetTimelineStopsInfoResponse> {
    return serverAxios
      .get(`${TimelineHttp.route}/stops/${id}`, {
        signal: abortController?.signal,
        timeout: HttpTimeoutPriority.Medium,
      })
      .then((response: AxiosResponse<IGetTimelineStopsInfoResponse>) => {
        return response.data;
      });
  }
}

export default TimelineHttp;
